import { useEffect } from "react";
import { useApplicantLoanInfo } from "../../applicant/api/getApplicantGoalInfo";
import { getConfigs } from "../../../config";

export const GetLoanTrackingSettings = () => {
  const applicantInfo = useApplicantLoanInfo();

  useEffect(() => {
    if (applicantInfo.isSuccess && applicantInfo?.data) {
      let applicantId = getConfigs().applicants[0].applicantId;

      let enabled = applicantInfo.data.enabledApplicants.filter(it => it.referenceId == applicantId).length > 0;

      let loanTrackerEnabledEvent = new CustomEvent("goalTrackerSettings", {
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {
          loanTrackingEnabled: enabled && applicantInfo?.data?.status === "Registered" || false,
        },
      });

      window.dispatchEvent(loanTrackerEnabledEvent);
    }
  }, [applicantInfo?.data?.status]);

  return (<></>);
};
